import type { RootState } from './root.types';

export function getDefaultState(): RootState {
  return {
    authId: null,
    documentId: null,
    recipientId: null,
    userId: null,
    isPreview: false,
    previewExpired: false,
    pusherConnected: false,
  };
}
